import React from 'react';
import { Button } from '../../components/ui/button';
import LabelTooltip from '../../components/LabelTooltip';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { useExtCustomColumns } from '../../contexts/extractions/ExtCustomColumnContext';
import { useSelector } from 'react-redux';

const RightButton = ({ stepVal }) => {
    const { addNewCustomColumn } = useExtCustomColumns();
    const { extractionViewOnly } = useSelector((state) => state.Extractions);

    return (
        <>
            {stepVal === 3 && (
                <div className="flex items-center">
                    <Button variant="border_outline" onClick={addNewCustomColumn} disabled={extractionViewOnly}>
                        Add Custom Column
                    </Button>
                    <LabelTooltip
                        variant='xl'
                        Icon={InformationCircleIcon}
                        content={
                            <span className="ml-auto max-w-[200px] text-center">
                                Logic for the custom columns will be derived from the selected columns
                            </span>
                        }
                    />
                </div>
            )}
        </>
    );
};

export default RightButton;